let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("laSZU")).then(() => parcelRequire('lQiW1'));